/** @jsx jsx */
import { jsx } from '@emotion/core';
import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { defaultTheme, ThemeProvider } from '../../theme';
import { PrimaryItemsContainer } from '../PrimaryItemsContainer';
import { containerCSS, leftCSS, rightCSS } from './styles';
const analyticsData = {
  attributes: {
    navigationLayer: 'global'
  },
  componentName: 'atlassianNavigation'
};
export const AtlassianNavigation = props => {
  const {
    label: label,
    primaryItems = [],
    renderAppSwitcher: AppSwitcher,
    renderCreate: create,
    renderHelp: Help,
    renderNotifications: Notifications,
    renderProductHome: ProductHome,
    renderProfile: Profile,
    renderSearch: Search,
    renderSignIn: SignIn,
    renderSettings: Settings,
    moreLabel = '…',
    theme = defaultTheme,
    testId
  } = props;
  return jsx(ThemeProvider, {
    value: theme
  }, jsx(NavigationAnalyticsContext, {
    data: analyticsData
  }, jsx("header", {
    css: containerCSS(theme),
    "data-testid": testId && `${testId}-header`,
    role: "banner"
  }, jsx("nav", {
    css: leftCSS,
    "aria-label": label
  }, AppSwitcher && jsx(AppSwitcher, null), ProductHome && jsx(ProductHome, null), jsx(PrimaryItemsContainer, {
    testId: testId,
    moreLabel: moreLabel,
    items: primaryItems,
    create: create,
    theme: theme
  })), jsx("div", {
    css: rightCSS,
    "data-testid": testId && `${testId}-secondary-actions`
  }, Search && jsx(Search, null), Notifications && jsx(Notifications, null), Help && jsx(Help, null), Settings && jsx(Settings, null), SignIn && jsx(SignIn, null), Profile && jsx(Profile, null)))));
};
export default AtlassianNavigation;